import { databaseTime } from "@intrasync/utils";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import React, { PureComponent } from "react";
import { TimeView } from "@mui/x-date-pickers";

interface TimePickerProps {
  views?: TimeView;
  label: string;
  value: string | Date | null;
  onChange: (value: string) => void;
  variant?: "outlined" | "filled" | "standard";
  showClearButton?: boolean;
}

class TimePicker extends PureComponent<TimePickerProps> {
  static defaultProps = {
    views: ["hours", "minutes"],
    variant: "standard",
  };

  render() {
    const { views, label, value, onChange, variant } = this.props;
    let timeValue: Date | null = null;

    if (!value || value === "00:00") {
      timeValue = null;
    } else if (value instanceof Date) {
      timeValue = value;
    } else if (typeof value === "string") {
      timeValue = new Date(value);
    }
    console.log("timeValue", timeValue);

    return (
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <MobileTimePicker
          view={views}
          ampmInClock={true}
          label={label}
          value={timeValue}
          onChange={(value: Date | null) => {
            return onChange(value ? databaseTime(value.toISOString()) : "");
          }}
          slotProps={{ textField: { variant } }}
        />
      </LocalizationProvider>
    );
  }
}

export default TimePicker;
